import followCursorBadge from "../utils/followCursorBadge";

// Badge "Découvrir" + lien du carrousel 3D. La rotation libre est entièrement gérée par le moteur
// Three.js (bundle-solutions.min.js, cf. app/js/Solutions3D.js) : cette classe ne touche qu'au badge
// et au lien, pas au rendu 3D.
export default class BlockSolutionsCarousel {
	constructor() {
		const blocks = document.querySelectorAll(".block-solutions-carousel");
		if (!blocks.length) return;

		blocks.forEach((block) => {
			const stage = block.querySelector(".block-solutions-carousel-stage");
			if (!stage) return;

			followCursorBadge(stage, block.querySelector(".cursor-badge"));

			// Le stage couvre plusieurs cartes à la fois : le lien suit celle qui est réellement sous
			// le pointeur (raycast côté moteur 3D) et retombe sur le lien du bloc quand on survole le
			// vide entre les cartes. `pointerdown` en plus de `mousemove` : il précède toujours le
			// `click` que DataLink écoute, y compris au doigt où aucun mousemove ne se produit.
			const blockLink = stage.dataset.link;
			let instance = null;

			window.addEventListener("solutionsCards3dReady", (e) => {
				if (e.detail.root === block) instance = e.detail.instance;
			});

			const syncCardLink = (e) => {
				const link = instance && instance.linkAt(e.clientX, e.clientY);
				stage.dataset.link = link || blockLink;
			};

			stage.addEventListener("mousemove", syncCardLink);
			stage.addEventListener("pointerdown", syncCardLink);
		});
	}
}
